































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class SalesReportTable extends Vue {
  @Prop({ required: true }) data!: number[];
  @Prop({ required: true }) purchaseData!: number[];
  @Prop({ required: true }) profitabilityData!: number[];
  @Prop({ required: true }) labels!: string[];

  formatter = Intl.NumberFormat("ja-JP", {
    style: "currency",
    currency: "JPY"
  });

  percentFormatter = Intl.NumberFormat("ja-JP", {
    style: "percent"
  });
}
